/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ListInvoices200ResponseItemsInnerCurrencyCode
 */
export interface ListInvoices200ResponseItemsInnerCurrencyCode {
}

/**
 * Check if a given object implements the ListInvoices200ResponseItemsInnerCurrencyCode interface.
 */
export function instanceOfListInvoices200ResponseItemsInnerCurrencyCode(value: object): value is ListInvoices200ResponseItemsInnerCurrencyCode {
    return true;
}

export function ListInvoices200ResponseItemsInnerCurrencyCodeFromJSON(json: any): ListInvoices200ResponseItemsInnerCurrencyCode {
    return ListInvoices200ResponseItemsInnerCurrencyCodeFromJSONTyped(json, false);
}

export function ListInvoices200ResponseItemsInnerCurrencyCodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListInvoices200ResponseItemsInnerCurrencyCode {
    return json;
}

export function ListInvoices200ResponseItemsInnerCurrencyCodeToJSON(json: any): ListInvoices200ResponseItemsInnerCurrencyCode {
    return ListInvoices200ResponseItemsInnerCurrencyCodeToJSONTyped(json, false);
}

export function ListInvoices200ResponseItemsInnerCurrencyCodeToJSONTyped(value?: ListInvoices200ResponseItemsInnerCurrencyCode | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

